import { forwardRef } from "react";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const ScreenNews = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon viewBox="0 0 32 32" ref={ref} {...props}>
      <path d="M29.091 2.133H2.909C1.309 2.133 0 3.466 0 5.096v17.778c0 1.63 1.309 2.963 2.909 2.963h7.273v1.481c0 .815.655 1.481 1.455 1.481h8.727c.8 0 1.455-.667 1.455-1.481v-1.481h7.273c1.6 0 2.909-1.333 2.909-2.963V5.096c0-1.63-1.309-2.963-2.909-2.963h-.001zm-1.455 20.741H4.363c-.8 0-1.455-.667-1.455-1.481V6.578c0-.815.655-1.481 1.455-1.481h23.273c.8 0 1.455.667 1.455 1.481v14.815c0 .815-.655 1.481-1.455 1.481zM24.727 9.541H11.636c-.8 0-1.455.667-1.455 1.481s.655 1.481 1.455 1.481h13.091c.8 0 1.455-.667 1.455-1.481s-.655-1.481-1.455-1.481zm0 5.926H11.636c-.8 0-1.455.667-1.455 1.481s.655 1.481 1.455 1.481h13.091c.8 0 1.455-.667 1.455-1.481s-.655-1.481-1.455-1.481zm-16-5.926H5.818v2.963h2.909V9.541zm0 5.926H5.818v2.963h2.909v-2.963z"/>
    </SvgIcon>
  );
});

ScreenNews.displayName = "ScreenNews";

export default ScreenNews;
